import { create } from 'zustand'
import {
  readPreferredSalonId,
  writePreferredSalonId,
  clearPreferredSalonId,
  subscribePreferredSalon,
} from '../lib/preferredSalon'

interface CallState {
  isOpen: boolean
  /** Same value as the booking store's preferredSalonId - single source of truth. */
  preferredCallSalonId: string | null
  open: () => void
  close: () => void
  setPreferred: (id: string, remember: boolean) => void
  clearPreferred: () => void
}

export const useCallStore = create<CallState>((set) => ({
  isOpen: false,
  preferredCallSalonId: readPreferredSalonId(),
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  setPreferred: (id, remember) => {
    if (remember) {
      writePreferredSalonId(id)
      set({ preferredCallSalonId: id })
    }
  },
  clearPreferred: () => {
    clearPreferredSalonId()
    set({ preferredCallSalonId: null })
  },
}))

subscribePreferredSalon((id) => {
  if (useCallStore.getState().preferredCallSalonId !== id) {
    useCallStore.setState({ preferredCallSalonId: id })
  }
})
